import ConsignmentInfoForm from '@Forms/ConsignmentInfoForm';

class ConsignmentSection extends React.Component {

    static modelToState(props) {
        return {
            AuctioneerCheckBoxHandler: props.model.AuctioneerCheckBoxHandler,
            Auctioneers: props.model.Auctioneers,
            PreferredSaleDateList: props.model.PreferredSaleDateList,
            PreferredSaleDateSelected: props.model.PreferredSaleDateSelected,
            IsRegisteredUser: props.model.IsRegisteredUser,
            CurrentSite: props.model.CurrentSite,
            QueryString: props.masterViewModel.QueryString,
            Translations: props.model.Translations,
            HighlightErrors: {},
            FormErrors: [],
            InputErrors: {},
            SelectedConsignorCRMID: props.model.SelectedConsignorCRMID,
            SelectedConsignorName: props.model.SelectedConsignorName
        };
    }

    constructor(props) {
        super(props);

        this.state = ConsignmentSection.modelToState(props);

        this.validatorConsignment = this.validatorConsignment.bind(this);
        this.handleFormUpdate = this.handleFormUpdate.bind(this);

        //updates the parent's validator to use this method 
        var masterViewState = this.props.masterViewModel;
        masterViewState.validatorConsignment = this.validatorConsignment;
        this.state.IsInTranslationEditorMode = this.props.masterViewModel.IsInTranslationEditorMode;
        this.props.handleFormUpdate(masterViewState);
    }

    //Handle Form changes
    handleFormUpdate(Model) {
        this.setState({
            AuctioneerCheckBoxHandler: Model.AuctioneerCheckBoxHandler,
            Auctioneers: Model.Auctioneers,
            PreferredSaleDateList: Model.PreferredSaleDateList,
            PreferredSaleDateSelected: Model.PreferredSaleDateSelected,
            HighlightErrors: Model.HighlightErrors,
            FormErrors: Model.FormErrors,
            InputErrors: Model.InputErrors
        });
        this.handleMasterUpdate(Model);
    }

    handleMasterUpdate(Model) {
        var masterViewState = this.props.masterViewModel;
        masterViewState.ConsignmentViewModel = Model;
        this.props.handleFormUpdate(masterViewState);
    }

    handleButtonClick(btn) {
        switch (btn) {
            case "done":
                //validate this form
                var bNoErrors = this.validatorConsignment(this.state);

                if (bNoErrors) {
                    //fire the addListingConsignor DL function here
                    if (!dataLayer_ContainsEvent(gTagEvents.addListingConsigner)) {
                        window.dataLayer.push({
                            "event": gTagEvents.addListingConsigner
                        });
                    }
                    //call the ConsignmentSectionDone function in the SinglePageUI js to collapse this accordion
                    ConsignmentSectionDone();
                }
                break;
            default:
                break;
        }
    }

    //Methods
    validatorConsignment(state) {

        state = state || this.state;
        var bHasErrors = false;
        var formErrors = [];
        var highlightErrors = {};
        var inputErrors = {};
        var bFirstError = true;
        var firstErrorElement = {};

        var bAtLeastOneCheckedAuctioneer = false;
        for (let key in this.state.Auctioneers) {
            if (this.state.AuctioneerCheckBoxHandler[key]) {
                bAtLeastOneCheckedAuctioneer = true;
            }
        };
        //they have to have at least one auctioneer
        if (!bAtLeastOneCheckedAuctioneer) {
            formErrors.push("At Least One Auctioneer is Required");
            inputErrors.AuctioneerCheckBoxHandler = "";
            if (bFirstError) {
                bFirstError = false;
                firstErrorElement = $('.PreferredSaleDateSelected');
            }
        }

        //check if there is any errors, if not, validate location details
        bHasErrors = Object.keys(inputErrors).length != 0;

        //save details to xml if there is no errors
        if (!bHasErrors) {
            //clear errors on the page
            this.setState({
                HighlightErrors: highlightErrors,
                InputErrors: inputErrors,
                FormErrors: formErrors,
            });

            //build models and save this xml
            this.SaveXML(state, false);
            return true;
        }
        else {

            if (Object.keys(firstErrorElement).length != 0)
                ScrollToElement(firstErrorElement);

            this.setState({
                HighlightErrors: highlightErrors,
                InputErrors: inputErrors,
                FormErrors: formErrors,
            });
            return false;
        }
    }

    SaveXML(state, bAsync) {

        state = state || this.state;
        if (bAsync == null)
            bAsync = true;

        var CRMIDSToSave = [];
        for (let key in this.state.Auctioneers) {
            if (this.state.AuctioneerCheckBoxHandler[key])
                CRMIDSToSave.push(key.toString());
        };

        //async save fields 
        var ConsignmentViewModel = {
            CRMIDSToSave: CRMIDSToSave,
            PreferredSaleDateSelected: state.PreferredSaleDateSelected,
        }

        var objectToSend = {
            ConsignmentViewModel: ConsignmentViewModel,
        }

        var xhr = new XMLHttpRequest();
        xhr.open("POST", '/listinginput/details/SaveConsignmentInfo' + this.state.QueryString, bAsync);
        xhr.setRequestHeader("Content-type", "application/json");
        xhr.send(JSON.stringify(objectToSend));
    }

    getTranslation(key) {
        return this.state.IsInTranslationEditorMode ?
            <span dangerouslySetInnerHTML={{ __html: this.state.Translations[key] }}></span> :
            this.state.Translations[key];
    }

    handleKeyDown(e) {
        if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            this.handleButtonClick("done");
            let tagetElement = this.state.IsRearrangedSite ? document.getElementById("dropbox") : document.getElementById("PrivacyBtn");
            setTimeout(() => {
                if (tagetElement) {
                    tagetElement.focus();
                }
            }, 0);
        }
    }

    //render
    render() {
        return (
            <div className="accordion cf" id="accordion-content-5">

                <div className="validationError" style={{ textAlign: 'center' }}>
                    <span>{this.state.FormErrors}</span>
                </div>
                <input type="hidden" value={this.state.SelectedConsignorCRMID} id="hdnConsignorCRMID" />
                <input type="hidden" value={this.state.SelectedConsignorName } id="hdnConsignorName"/>
                <ConsignmentInfoForm
                    model={this.state}
                    masterViewModel={this.props.masterViewModel}
                    handleFormUpdate={(e) => { this.handleFormUpdate(e); }}
                    SaveXML={(state) => { this.SaveXML(state); }}
                />
                <button role="link" className="form-btn" id="info-done-btn-consignment" onKeyDown={(e) => { this.handleKeyDown(e) }} onMouseUp={(e) => { this.handleButtonClick("done"); }}>{this.getTranslation("DoneWithConsignment")}</button>
            </div>
        );
    }
}

export default ConsignmentSection;
global.ConsignmentSection = ConsignmentSection;